import { Link } from 'react-router-dom';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';

/**
 * The refusal when I try to invite, post or message before verifying an
 * email or phone (019 R19): the server's words, and where to verify.
 * Whatever I typed stays where it was.
 */
export default function VerifyFirstNotice({
  message,
  className,
}: {
  message: string;
  className?: string;
}) {
  return (
    <Alert role="alert" className={`rounded-2xl border-none bg-wood/15 ${className ?? ''}`}>
      <ShieldAlert className="size-4 text-wood" aria-hidden="true" />
      <AlertDescription className="flex flex-wrap items-center gap-x-3 gap-y-1 text-foreground">
        <span>{message}</span>
        <Link
          to="/settings/account#emails-and-phones"
          className="font-semibold text-primary hover:underline"
        >
          Verify an email or phone
        </Link>
      </AlertDescription>
    </Alert>
  );
}
